(function(){
  function init(root){
    if(!root||root.getAttribute('data-ready'))return;
    var dataEl=root.querySelector('[data-mt-data]');
    if(!dataEl)return;
    root.setAttribute('data-ready','1');
    var data=JSON.parse(dataEl.textContent);
    var fmt=null;
    try{fmt=new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:data.currency});}catch(e){}
    function money(c){return fmt?fmt.format(c/100):(c/100).toFixed(2)+' '+data.currency;}
    var idSel='product-form form[action*="/cart/add"] [name="id"]';
    function idInputs(){return document.querySelectorAll(idSel);}
    var pf=document.querySelector('product-form');
    if(pf&&pf.parentNode&&root.nextElementSibling!==pf){pf.parentNode.insertBefore(root,pf);}
    var state={mode:'solo',opts:[],addonId:null};
    for(var a=0;a<data.addon.length;a++){if(data.addon[a].available){state.addonId=data.addon[a].id;break;}}
    function byId(id){for(var i=0;i<data.variants.length;i++){if(String(data.variants[i].id)===String(id))return data.variants[i];}return null;}
    function match(o){for(var i=0;i<data.variants.length;i++){var v=data.variants[i],ok=true;for(var j=0;j<o.length;j++){if(v.options[j]!==o[j]){ok=false;break;}}if(ok)return v;}return null;}
    function addonVariant(){for(var i=0;i<data.addon.length;i++){if(String(data.addon[i].id)===String(state.addonId))return data.addon[i];}return data.addon[0];}
    function setText(sel,txt){var els=root.querySelectorAll(sel);for(var i=0;i<els.length;i++){els[i].textContent=txt;}}
    function hidePicker(){
      var els=document.querySelectorAll('variant-selects,variant-radios');
      for(var i=0;i<els.length;i++){els[i].style.display='none';}
    }
    function applyMode(){
      root.setAttribute('data-mode',state.mode);
      var els=document.querySelectorAll('.shopify-payment-button');
      for(var i=0;i<els.length;i++){els[i].style.display=state.mode==='bundle'?'none':'';}
    }
    function formsSync(){
      var v=match(state.opts);if(!v)return;
      var els=idInputs();for(var i=0;i<els.length;i++){els[i].value=v.id;}
    }
    function syncMain(v){
      try{
        var boxes=document.querySelectorAll('variant-selects,variant-radios');
        for(var b=0;b<boxes.length;b++){
          var radios=boxes[b].querySelectorAll('input[type="radio"]');
          for(var r=0;r<radios.length;r++){
            if(v.options.indexOf(radios[r].value)>-1&&!radios[r].checked){radios[r].click();}
          }
          var sels=boxes[b].querySelectorAll('select');
          for(var s=0;s<sels.length;s++){
            for(var o=0;o<v.options.length;o++){
              var has=false;
              for(var q=0;q<sels[s].options.length;q++){if(sels[s].options[q].value===v.options[o]){has=true;break;}}
              if(has&&sels[s].value!==v.options[o]){sels[s].value=v.options[o];sels[s].dispatchEvent(new Event('change',{bubbles:true}));}
            }
          }
        }
      }catch(e){}
    }
    function render(){
      var groups=root.querySelectorAll('[data-mt-chips]');
      for(var g=0;g<groups.length;g++){
        var gi=parseInt(groups[g].getAttribute('data-mt-chips'),10);
        var btns=groups[g].querySelectorAll('.mt-chip');
        for(var b=0;b<btns.length;b++){
          var val=btns[b].getAttribute('data-val');
          btns[b].setAttribute('aria-pressed',state.opts[gi]===val?'true':'false');
          var ok=false;
          for(var k=0;k<data.variants.length;k++){
            var v=data.variants[k];
            if(!v.available||v.options[gi]!==val)continue;
            var same=true;
            for(var m=0;m<state.opts.length;m++){if(m!==gi&&v.options[m]!==state.opts[m]){same=false;break;}}
            if(same){ok=true;break;}
          }
          btns[b].disabled=!ok;
        }
      }
      var cv=match(state.opts),av=addonVariant();
      if(!cv||!av)return;
      setText('[data-mt-price="solo"]',money(cv.price));
      setText('[data-mt-compare="solo"]',cv.compare>cv.price?money(cv.compare):'');
      var bp=cv.price+av.price;
      var bc=(cv.compare>cv.price?cv.compare:cv.price)+(av.compare>av.price?av.compare:av.price);
      setText('[data-mt-price="bundle"]',money(bp));
      setText('[data-mt-compare="bundle"]',bc>bp?money(bc):'');
    }
    function pick(g,val){
      var test=state.opts.slice();test[g]=val;
      var v=match(test);
      if(!v||!v.available){
        v=null;
        for(var i=0;i<data.variants.length;i++){if(data.variants[i].available&&data.variants[i].options[g]===val){v=data.variants[i];break;}}
      }
      if(!v)return;
      state.opts=v.options.slice();
      formsSync();syncMain(v);render();applyMode();
    }
    root.addEventListener('change',function(e){
      var t=e.target;
      if(t&&t.name&&t.name.indexOf('mt-bundle-mode-')===0){state.mode=t.value;applyMode();}
      else if(t&&t.hasAttribute&&t.hasAttribute('data-mt-addon')){state.addonId=t.value;render();}
    });
    root.addEventListener('click',function(e){
      var b=e.target.closest?e.target.closest('.mt-chip'):null;
      if(!b||b.disabled)return;
      pick(parseInt(b.parentNode.getAttribute('data-mt-chips'),10),b.getAttribute('data-val'));
    });
    var v0=byId(data.selected)||data.variants[0];
    state.opts=v0.options.slice();
    hidePicker();render();applyMode();
    var busy=false;
    if(window.__mtBundleHandler){document.removeEventListener('submit',window.__mtBundleHandler,true);}
    window.__mtBundleHandler=function(e){
      var f=e.target;
      if(busy||!f||!f.matches||!f.matches('form[action*="/cart/add"]')||!f.closest('product-form'))return;
      formsSync();
      if(state.mode!=='bundle'||!state.addonId)return;
      e.preventDefault();e.stopImmediatePropagation();
      var msg=root.querySelector('[data-mt-msg]');if(msg)msg.hidden=true;
      var qEl=document.getElementById('hiddenQuantityInput')||f.querySelector('[name="quantity"]');
      var qty=parseInt(qEl&&qEl.value?qEl.value:'1',10);if(!(qty>0))qty=1;
      var rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      function go(){
        busy=true;
        try{if(f.requestSubmit){f.requestSubmit();}else{f.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));}}finally{busy=false;}
      }
      fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(state.addonId),quantity:qty,properties:{'_pack':'Chaleco + Orejeras'}}]})})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
        .then(function(res){
          if(!res.ok&&msg){msg.textContent='No hemos podido añadir las orejeras. Se añadirá solo el chaleco.';msg.hidden=false;}
          go();
        })
        .catch(function(){go();});
    };
    document.addEventListener('submit',window.__mtBundleHandler,true);
  }
  function boot(){
    var roots=document.querySelectorAll('[data-mt-bundle]');
    for(var i=0;i<roots.length;i++){init(roots[i]);}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',boot);
})();